import styled from 'styled-components';

export const ScheduleSection = styled.div`
  display: flex;
  gap: 32px;
  width: 100%;
  margin-bottom: 16px;
`;

export const ScheduleDescription = styled.div`
  width: 180px;
  min-width: 180px;
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  padding-top: 12px;
`;

export const DayScheduleWrapper = styled.div`
  flex: 1;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #52c41a;
    border-color: #52c41a;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #52c41a;
  }
`;

export const DayRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 14px 20px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const DayLabel = styled.span`
  width: 130px;
  min-width: 130px;
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
`;

export const ClosedLabel = styled.span`
  color: #bfbfbf;
  font-size: 13px;
  line-height: 32px;
`;

export const PeriodRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

/**
 * Wrapper for a single period slot (PeriodRow + optional HintText).
 * Needs to carry the top spacing itself because PeriodRow is nested inside
 * this div, so a `:not(:first-child)` selector on PeriodRow never fires.
 */
export const PeriodBlock = styled.div`
  &:not(:first-child) {
    margin-top: 14px;
  }
`;

export const PeriodsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const HintText = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  color: #888;
`;

export const EmptyState = styled.div`
  padding: 20px 24px;
  color: #999;
  font-size: 13px;
  text-align: center;
  border: 1px dashed #e8e8e8;
  border-radius: 8px;
`;
